/**
 * Edit / duplicate / remove controls for a lander or offer row.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC } from 'react';
import { Copy, Pencil, Trash2 } from 'lucide-react';

import { Button } from '@/components/ui/layout/Button';
import { Tooltip } from '@/components/ui/Tooltip';

export interface PathItemRowActionsProps {
  onEdit: () => void;
  onDuplicate: () => void;
  onRemove: () => void;
  entityLabel: 'lander' | 'offer';
}

const PathItemRowActions: FC<PathItemRowActionsProps> = ({
  onEdit,
  onDuplicate,
  onRemove,
  entityLabel,
}) => (
  <div className="flex shrink-0 items-center gap-0.5">
    <Tooltip content={`Edit ${entityLabel}`}>
      <Button
        type="button"
        variant="ghost"
        size="icon"
        className="h-7 w-7 text-primary hover:bg-primary/10"
        onClick={onEdit}
        aria-label={`Edit ${entityLabel}`}
      >
        <Pencil className="h-3.5 w-3.5" aria-hidden />
      </Button>
    </Tooltip>
    <Tooltip content={`Duplicate ${entityLabel}`}>
      <Button
        type="button"
        variant="ghost"
        size="icon"
        className="h-7 w-7 text-primary hover:bg-primary/10"
        onClick={onDuplicate}
        aria-label={`Duplicate ${entityLabel}`}
      >
        <Copy className="h-3.5 w-3.5" aria-hidden />
      </Button>
    </Tooltip>
    <Tooltip content="Remove">
      <Button
        type="button"
        variant="ghost"
        size="icon"
        className="h-7 w-7 text-destructive hover:bg-destructive/10 hover:text-destructive"
        onClick={onRemove}
        aria-label={`Remove ${entityLabel}`}
      >
        <Trash2 className="h-3.5 w-3.5" aria-hidden />
      </Button>
    </Tooltip>
  </div>
);

export default PathItemRowActions;
